import { ICartEntry } from '@rbi-ctg/menu';

import {
  getItemLoyaltyRewardDiscount,
  getItemOfferDiscount,
} from '../../../../../state/cart-store/loyalty-helpers';
import { priceForCartEntry } from '../../../../../utils';

interface PriceCalculationResult {
  finalItemPrice: number;
  originalPrice: number;
  isFree: boolean;
  shouldShowStrikeThrough: boolean;
}

export function calculateItemPrice(
  item: ICartEntry,
  selectedOffer: any,
  offerEligibleItem: any,
  isRewardSelectionForItem: boolean
): PriceCalculationResult {
  const originalPrice = priceForCartEntry(item);
  const isOfferEligibleItem = !!offerEligibleItem;

  let finalItemPrice = originalPrice;

  if (isOfferEligibleItem) {
    const offerDiscount = getItemOfferDiscount({
      cartEntry: item,
      offer: selectedOffer,
      eligibleItem: offerEligibleItem,
    });
    finalItemPrice = finalItemPrice - offerDiscount;
  }

  // When a reward is selected but offerEligibleItem is not present (e.g. claiming from
  // /offers reward tiers where the backend eligible items evaluation clears it after a
  // brief period), apply the base item reward discount. Modifier upcharges remain in
  // finalItemPrice so the UI can display them.
  if (isRewardSelectionForItem && !isOfferEligibleItem) {
    const rewardDiscount = getItemLoyaltyRewardDiscount({ cartEntry: item });
    finalItemPrice = finalItemPrice - rewardDiscount;
  }

  const isFree = finalItemPrice === 0;
  const shouldShowStrikeThrough = isFree || isOfferEligibleItem || isRewardSelectionForItem;

  return {
    finalItemPrice,
    originalPrice,
    isFree,
    shouldShowStrikeThrough,
  };
}
